import ReactGA from 'react-ga4';
import { useSelector } from 'react-redux';

import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import { LocalizationProvider } from '@mui/x-date-pickers';
import configs from 'configs';
import 'dayjs/locale/zh-tw';
import NavigationScroll from 'layout/NavigationScroll';

// ==============================|| APP ||============================== //

ReactGA.initialize(configs.gaTrackId, {
    debug: configs.stage === 'development',
    titleCase: false
});

const App = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'zh-tw'}>
                    <CssBaseline />
                    <NavigationScroll>
                        <Routes />
                    </NavigationScroll>
                </LocalizationProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
